import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { groupListResponseType, saveRate } from "./AddOrEditPrice/type";
import { MasterTableDataType, SaveReference, SearchParamsType } from "./InsurancePriceList/type";
import { MasterTableDataType as rateList } from "./AddOrEditPrice/type";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const {clinicId,createdById} = getConstants()
const { MastersApi,patientEncounterApi } = api;
export const getPriceMastersTableData = async (
  params: SearchParamsType
): Promise<
  ResponseType<{ totalCount: number; items: MasterTableDataType[] }>
> => {
  const result = await instance.post(
    `${MastersApi.getAllReference}`,
    params
  );
  return result.data;
};

export const getNetwork = async (params: {
  clinicId: number;
  insType: number;
  insName: number;
  inGroupId?: number|null;
}) => {
  const result = await instance.post(`${MastersApi?.getNetwork}`, params);
  return result.data;
};

export const getAllCptGrpups=async():Promise<ResponseType<groupListResponseType[]>>=>{
    const result = await instance.get(`${MastersApi?.getcptGroups}${clinicId}`);
    return result.data;
}
export const getInsPlanService = async (params: {
  clinicId: number;
  insType: number;
  insName: number;
  inGroupId?: number | null;
  insNetworkId?: number | null;
}) => {
  const result = await instance.post(`${MastersApi?.getInsPlan}`, params);
  return result.data;
}

export const getAllInsuraceType=async():Promise<ResponseType<{id:number,name:string}[]>>=>{
  const result=await instance.get(`${patientEncounterApi?.getallinsType}${clinicId}`)
  return result.data
}

export const getAllInsurance=async(id:number):Promise<ResponseType<{id:number,name:string}[]>>=>{
  const body={
      searchText:null,
      typeId:id,
      clinicId
    }
  const result=await instance.post(patientEncounterApi.getInsByTpe,body)
  return result?.data
}
export const getInsurancePlan=async(id:number):Promise<ResponseType<{id:number,name:string}[]>>=>{
  const body={
      searchText:null,
      typeId:id,
      clinicId
    }
  const result=await instance.post(patientEncounterApi.getInsPlan,body)
  return result?.data
}



export const saveInsurancePriceMaster = async (
  data: SaveReference  
): Promise<ResponseType<MasterTableDataType>> => {
  const result = await instance.post(
    `${MastersApi?.saveReference}`,
    data
  );
  return result.data;
}

export const getCptByGroupId=async(params:{search:string,clinicId:number,groupId:number}):Promise<ResponseType<any>>=>{
    const result = await instance.post(`${MastersApi?.getCptBygrpId}`,params);
    return result.data;
}

export const saveRateService=async(data:saveRate):Promise<ResponseType<MasterTableDataType>>=>{
    const result = await instance.post(`${MastersApi?.saveRate}`,data);
    return result.data;
}

export const getRateTableService = async(params:SearchParamsType & {codetype:string}):Promise<ResponseType<{ totalCount: number; items: rateList[] }>>=>{
    const result = await instance.post(params.codetype === "CPT" ? `${MastersApi?.getRateTable}` : `${MastersApi?.getRateTablev2}`,params);
    return result.data;
}


export const uploadFile = async ({file,refId}:{file:File,refId:number}):Promise<ResponseType<string>>=>{
    const formData = new FormData();
    formData.append("clinicId", `${clinicId}`);
    formData.append("createdById", `${createdById}`);
    formData.append("file", file);
    formData.append("referenceId", `${refId}`);
    const result = await instance.post(`${MastersApi.priceListUpload}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return result.data;
}

